import { useQuery } from "@tanstack/react-query";
import { Collections } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
import { COLLECTIONS_QUERY_KEY } from "./useCollections";
const getCollection = async ({ id }) => Collections.get(id);
const useCollection = (collectionId, { enabled } = { enabled: true }) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [COLLECTIONS_QUERY_KEY, collectionId],
    queryFn: () => defaultOnError(
      getCollection({ id: collectionId }),
      `Loading Collection ${collectionId} failed with status`,
      `Could not load Collection ${collectionId}`
    ),
    enabled
  });
  return {
    data,
    isLoading,
    refetch
  };
};
export default useCollection;
